import { create } from 'zustand';

interface Speak2MeKickoffState {
  pendingKickoff: string | null;
  setPendingKickoff: (text: string) => void;
  clearPendingKickoff: () => void;
}

export const useSpeak2MeKickoffStore = create<Speak2MeKickoffState>((set) => ({
  pendingKickoff: null,
  setPendingKickoff: (pendingKickoff) => set({ pendingKickoff }),
  clearPendingKickoff: () => set({ pendingKickoff: null }),
}));
